import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';

@Component({
  selector: 'loyaltic-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  email: any;
  constructor(
    private coreService: CoreService, 
    private toast: ToastrService, 
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.authService.resetTokens();
  }

  onSubmit(formRef) {
    this.coreService.forgotPassword(this.email).then((forgotPasswordResponse: any) => {
      //this.toast.success('Mail sent successfully!', 'Success');
      const successMessage = this.translate.instant(forgotPasswordResponse.messageKey);
      this.toast.success(successMessage, '');
      this.router.navigate(['/']);
    }).catch((errorResponse: any) => {
      if (errorResponse.error.messageKey === 'error-already-registered') {
        //this.toast.error('User already exists, try with  other email', 'Error');
        const errorMessage = this.translate.instant(errorResponse.messageKey);
        this.toast.error(errorMessage, '');
        return;
      }
    });
  }

}
